import { Box, Button, Grid, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useMemberContext } from '../../context/memberContext';
import dayjs from 'dayjs';
import { BasicDatePicker } from '../../shared/basicDatePicker';



export default function MemberInfoTab() {

    const [firstName, setFirstName] = React.useState<string>('');
    const [lastName, setLastName] = React.useState<string>('');
    const [birthDate, setBirthDate] = React.useState<string>('');
    const [email, setEmail] = React.useState<string>('');
    const [phone, setPhone] = React.useState<string>('');

    const { member, isLeader, updateName, updateBirthDate, updateContactInfo} = useMemberContext();
    const { isAuthenticated } = useAuth0();

    useEffect(() => {
        if (member) {
            setFirstName(member.firstName);
            setLastName(member.lastName);
            setBirthDate(dayjs(member.birthDate).isValid() ? dayjs(member.birthDate).format() : '');
            setEmail(member.email ?? '');
            setPhone(member.phone ?? '');
        }
    }, [member]);

    const handleFirstNameChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setFirstName(value);
    };

    const handleLastNameChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setLastName(value);
    };



    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleUpdateName = async () => {
        await updateName(firstName, lastName);
    }

    const handleUpdateBirthDate = async () => {
            await updateBirthDate(birthDate);
    }

    const handleUpdateEmail = async () => {
        await updateContactInfo(phone, email);
    }

    return (
        <Grid container spacing={3}>
            <Grid container item xs={12} spacing={1}>
                <Grid item xs={3}>

                    <Box>
                        <TextField id="firstName"
                            label="First Name"
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 25 }}
                            value={firstName}
                            style={{ width: 200 }}
                            onChange={handleFirstNameChange} />
                    </Box>

                </Grid>
                <Grid item xs={3}>

                    <Box>
                        <TextField id="lastName"
                            label="Last Name"
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 25 }}
                            value={lastName}
                            style={{ width: 200 }}
                            onChange={handleLastNameChange} />
                    </Box>

                </Grid>
                
                <Grid item xs={3}>

                    <Box>
                        {isAuthenticated && <Button variant='contained' onClick={handleUpdateName}>Update Name</Button>}
                    </Box>

                </Grid>
            </Grid>


            <Grid container item xs={12} spacing={1}>

                <Grid item xs={3}>

                <Box>

                    <BasicDatePicker width={250}
                       label='Birthdate'
                       value={birthDate}
                       onChange={(date) => setBirthDate(date ? date : '')} />

                    </Box>

                </Grid>

                <Grid item xs={2}>
                    {isAuthenticated && <Button variant='contained' onClick={handleUpdateBirthDate}>Update</Button>}
                </Grid>

            </Grid>




            <Grid container item xs={12} spacing={1}>

                <Grid item xs={3}>
                    <Box>
                        <TextField id="email"
                            label="Email"
                            variant="outlined"
                            size="small"
                            helperText='20 character limit'
                            inputProps={{ maxLength: 50 }}
                            value={email}
                            style={{ width: 275 }}
                            onChange={handleEmailChange} />
                    </Box>
                </Grid>

                <Grid item xs={2}>
                    {isAuthenticated && <Button variant='contained' onClick={handleUpdateEmail}>Update</Button>}
                </Grid>
            </Grid>

           
        </Grid>
    )
}